export default __webpack_public_path__ + "static/media/OpenItemReport.dfb164c0.svg";